import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const Customer = Loadable({
  loader: () => import("./Customer"),
  loading: Loading
})
